import CreateForgeAppBtn from "./CreateForgeAppBtn";

import "../../utils/_fonts.scss";
import "../../utils/_fui-bs3-fix.scss";
import '@hig/icon/build/index.css';
import "./style.scss";

export default CreateForgeAppBtn;
